
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ketentuan-layanan",
      function () {
        return require("private-next-pages/ketentuan-layanan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ketentuan-layanan"])
      });
    }
  